import { key } from "./../../store/index";
import {
  ref,
  computed,
  reactive,
  defineComponent,
  toRefs,
  onMounted,
  toRef,
  nextTick,
  watch,
} from "vue";
import { HttpService } from "@/core/index";
import PrintItem from "./header.vue";
import { TabService } from "@/core";
import ApprovalFlowLogTable from "./approval-flow-log/index.vue";
import Attachment from "./attachment-table/index.vue";
import moment from "moment";
import { useRouter } from "vue-router";
import LostOrderBtn from "@/views/project/profile/detail/lost-order-btn.vue";
import { collapsed } from "@/utils/windowResize";
import { setDesLabelWidth } from "@/utils/index";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { flowStatusArr } from "../status-tabs/status-tabs.constant";
import { ApprovalFlowLogService } from "./approval-flow-log/approval-flow-log.service";
export default defineComponent({
  isGlobal: true,
  name: "FormDetail",
  components: { PrintItem, ApprovalFlowLogTable, Attachment, LostOrderBtn },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    attachBizType: {
      type: String,
      default: "",
    },
    flowBizType: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    qrcodeUrl: {
      type: String,
      default: "",
    },
    editUrl: {
      type: String,
      default: "",
    },
    editPerm: {
      type: String,
      default: "",
    },
    changePerm: {
      type: String,
      default: "",
    },
    examinePerm: {
      type: String,
      default: "",
    },
    recoverAccess: {
      type: String,
      default: "",
    },
    completelyDeleteAccess: {
      type: String,
      default: "",
    },
    deleteAccess: {
      type: String,
      default: "",
    },
    listComponentName: {
      type: String,
      default: "",
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    bizNoLabelName: {
      type: String,
      default: "",
    },
    validStatusLabelName: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: Number,
      default: 100,
    },
    bizName: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    createBy: {
      type: String,
      default: "",
    },
    notVoid: {
      type: Boolean,
    },
    flowStatusKeyName: {
      type: String,
      default: "status",
    },
    bizNameKey: {
      type: String,
      default: "name",
    },
    contractStatusLabelNameKey: {
      type: String,
      default: "",
    },
    useNew: {
      type: Boolean,
      default: false,
    },
    // 主表对象名称字段（接口返回多了一层级）
    recordNameKey: {
      type: String,
    },
    statusKey: {
      type: String,
      default: "status",
    },
    other:{
      type:Function
    }
  },
  emits: ["update:basicInfo", "update:attachList", "refresh","update:dataSource"],
  setup(props, { emit }) {
    const router = useRouter();
    const state = reactive({
      collapsed,
      showLostOrderBtn: computed(() => {
        return (
          (state.flowStatus === "dtj" && !state.flowType) ||
          (state.flowStatus === "ycx" && state.flowType === "tjsp") ||
          (state.flowStatus === "spbtg" && state.flowType === "tjsp")
        );
      }),
      showEditBtn: false,
      showEdit: computed(() => {
        return (state.showEditBtn && props.status !== "ygb")&&(basicInfo.value['isRecycled']!=1); //修改丢单的情况下，不显示编辑按钮
      }),
      flowStatus: "",
      flowType: "",
      id: computed(() => {
        let t = props.url.split("/");
        t = t[t.length - 1].split('?');
        return props.url.indexOf('?') > -1 ? t[t.length - 2]:t[t.length - 1];
      }),
      nowStr: moment().format("YYYY/MM/DD HH:mm"),
      selectedCheckbox: [],
      selectedSection: [
        { label: "标题", value: "header", sort: 1, show: true },
        { label: "基本信息", value: "basic", sort: 2, show: true },
        { label: "附件", value: "attach", sort: 10, show: true },
        { label: "协作日志", value: "flow", sort: 11, show: true },
      ],
      checkboxes: computed(() => {
        let tmp = [] as any;
        props.sections.forEach((o: any) => {
          !o["visible"] && (o["visible"] = () => true);

          let t = state.selectedSection.findIndex((i: any) => i.value === o.value);
          if (t < 0) {
            tmp.push(o);
          } else {
            state.selectedSection[t] = Object.assign(state.selectedSection[t], o);
          }
        });
        tmp = [...state.selectedSection, ...tmp];
        tmp.sort((a: any, b: any) => {
          if (a.sort > b.sort) {
            return 1;
          } else if (a.sort < b.sort) {
            return -1;
          } else {
            return 0;
          }
        });
        return tmp;
      }),
      loopSection: computed(() => {
        const tmp = [] as any;
        state.selectedCheckbox.forEach((o) => {
          const t = state.checkboxes.find((i: any) => i.value === o);
          if (t) {
            tmp.push(t);
          }
        });
        return tmp;
      }),
      showQrcode: computed(() => {
        return state.loopSection.some((i) => i.value === "qrcode" && i.show);
      }),
      showAttach: computed(() => {
        return state.loopSection.some((i) => i.value === "attach" && i.show);
      }),
      printConfig: {
        id: "#flow-print-table",
        popTitle: ".",
      },
      disabledVoid: computed(() => {
        if (props.flowBizType === "borrow_seal_examine") {
          return basicInfo.value?.borrowSealState == "3";
        } else if (props.flowBizType === "use_seal_examine") {
          return true;
        } else if (props.flowBizType === "resign_apply_examine") {
          return true;
        } else if (props.flowBizType === "invoice_application_examine" && props.notVoid === true) {
          return true;
        }
        return false;
      }),
    });
    state.selectedCheckbox = state.checkboxes.map((o) => o.value);
    const isIframe = window.self !== window.top;

    watch(
      () => state.flowStatus,
      (n, o) => {
        if (n !== o) {
          // let name = flowStatusArr.find((v) => v.type === state.flowStatus)?.name || "";
          // // console.log("🚀 ~ file: controller.ts:187 ~ flowStatusName ~ name:", name);
          // flowStatusName.value = name;
          loadName();
        }
      }
    );
    const loadName = () => {
      // if (name && name != "") {
      //   if (basicInfo.value && basicInfo.value["flowStatusName"]) {
      //     basicInfo.value["flowStatusName"] = name;
      //   } else if (basicInfo.value) {
      //     for (let key in basicInfo.value) {
      //       if (
      //         typeof basicInfo.value[key] === "object" &&
      //         !Array.isArray(basicInfo.value[key]) &&
      //         basicInfo.value[key] != null &&
      //         basicInfo.value[key]["flowStatusName"]
      //       ) {
      //         basicInfo.value[key]["flowStatusName"] = name;
      //       }
      //     }
      //   }
      // }
      emit("update:basicInfo", basicInfo.value);
    };
    watch(
      () => state.selectedCheckbox,
      (n) => {
        if (n) {
          // console.log(n);
          nextTick(() => {
            setDesLabelWidth("ant-descriptions-item-label", props.labelWidth);
          });
        }
      },
      { immediate: true, deep: true }
    );

    const useDetailApi = () => {
      const api = (url) =>
        HttpService.axios({
          method: "GET",
          url,
        });
      return HttpService.useRequest<any>(api);
    };
    const useAttachListApi = () => {
      const api = (params) =>
        HttpService.axios({
          method: "GET",
          url: "/biz_file/page",
          params,
        });
      return HttpService.usePagination<any>(api);
    };

    const { run, data: basicInfo, refresh: refreshDetail, loading } = useDetailApi();
    const { run: runBatch, data: attachList, refresh: refreshFn } = useAttachListApi();
    const { data: dataSource,loading:logLoading,run:getLog,refresh:logRefresh } = ApprovalFlowLogService.useGetLogs();//获取协作日志
    const initData = async (n) => {
      console.log("🚀 ~ controller.ts:298 ~ initData ~ n:", n)
      if (n&&n.indexOf('undefined')==-1) {
       const res= await run(n);
        
        if (state.showAttach) {
          await runBatch({
            current: 1,
            size: 1000,
            bizId: state.id,
            bizType: props.attachBizType,
          });
          emit("update:attachList", attachList.value);
        }
        nextTick(() => {
          emit("update:basicInfo", basicInfo.value);
        });
       
        console.log("🚀 ~ file: controller.ts:255 ~ initData ~ basicInfo.value:", basicInfo.value,state.id);
      }
    };
    watch(
      () => props.url,
      async (n, o) => {
        // console.log(n, o);
        if (n) {
          initData(n);
        }
      },
      {
        immediate: true,
      }
    );
    const cancel = async () => {
      TabService.closeCurrentTab();
      router.back();
    };
    const goPrint = () => {
      // console.log(props.editUrl + "/flowPrint/" + state.id, "我是即将取往打印的路由");
      router.push(props.editUrl + "/flowPrint/" + state.id);
      if (isIframe) {//收起数据概览
        window.parent.postMessage({ type: 'setShowCard', data: false }, '*');
       }

    };
    const refresh = async () => {
     
      await refreshDetail();
      console.log("🚀 ~ controller.ts:341 ~ refresh ~ state.id:", state.id)
      if(state.id){
        console.log("🚀 ~ controller.ts:343 ~ refresh ~ state.id:", state.id)
        await getLog(state.id,props.flowBizType)
      }
      loadName();
      // console.log("🚀 ~ file: controller.ts:255 ~ initData ~ basicInfo.value:", basicInfo.value,state.id);
      emit("update:attachList", attachList.value);
      emit("update:dataSource",dataSource.value)
      emit("refresh", "");
    };

    onMountedOrActivated(() => {
      initData(props.url);
      nextTick(() => {
        setDesLabelWidth("ant-descriptions-item-label", props.labelWidth);
      });
    });
    const goto=(url)=>{
     router.push(url)
     if (isIframe) {//收起数据概览
      window.parent.postMessage({ type: 'setShowCard', data: false }, '*');
     }
    }
    return {
      ...toRefs(state),
      basicInfo,
      attachList,
      cancel,
      goPrint,
      refresh,
      loading,
      refreshFn,
      dataSource,
      isIframe,
      goto
    };
  },
});
